
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Banner from '../Header/Banner';
import Preloader from '../Preloder/Preloader';
import ClientCarousel from './ClientCarousel';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import DonationsCarousel from './DonationsCarousel';
import Stickeyheader from '../Header/Stickeyheader';
import axios from 'axios';
import { Link } from 'react-router-dom';


const Index = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [adminMode, setAdminMode] = useState(true); // Toggle between admin and student
  const [identifier, setIdentifier] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleShowPasswordChange = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (adminMode) {
      // Admin login
      if (!username || !password) {
        setError('Please fill in both fields.');
        return;
      }

      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/Admin/Login`,
          { username, password },
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.data.user) {
          const { username, role, UserId } = response.data.user;
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('username', username);
          localStorage.setItem('userRole', role);
          localStorage.setItem('UserId', UserId);
          if (role === 'admin' || role === 'supperadmin') {
            navigate('/admin');
          }
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Invalid username or password.');
      } finally {
        setLoading(false);
      }

    } else {
      // Student login
      if (!identifier.trim() || !password.trim()) {
        setError('Identifier and password are required.');
        return;
      }

      let identifierType = '';
      if (/^\d{12}$/.test(identifier)) {
        identifierType = 'aadhaar';
      } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier)) {
        identifierType = 'email';
      } else {
        identifierType = 'userId';
      }

      setLoading(true);
      try {
        const response = await axios.post(`${process.env.REACT_APP_API}/student/studentlogin`, {
          identifier,
          identifierType,
          password,
        });

        if (response.data.message === 'Login successful') {
          const { username, role, userId } = response.data.user;
          localStorage.setItem('username', username);
          localStorage.setItem('userRole', role);
          localStorage.setItem('UserId', userId);
          localStorage.setItem('isStudentLogin', 'true');
          navigate('/profile');
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Student login failed.');
      } finally {
        setLoading(false);
      }
    }
  };
    const options = {
      items: 3,
      margin: 30,
      smartSpeed: 700,
      loop: true,
      autoplay: true,
      autoplayTimeout: 6000,
      nav: false,
      dots: true,
      responsive: {
        0: { items: 1, margin: 20 },
        575: { items: 1, margin: 30 },
        768: { items: 2, margin: 30 },
        992: { items: 3, margin: 30 },
        1200: { items: 3, margin: 30 },
      },
    };
    const blogPosts = [
        {
          id: 1,
          image: 'assets/images/blog/blog-1-1.jpg',
          alt: 'Hope for children',
          title: 'Our donation is hope for poor children in Africa',
          date: '03 Sep',
        },
        {
          id: 2,
          image: 'assets/images/blog/blog-1-2.jpg',
          alt: 'Variations of Lorem Ipsum',
          title: 'There are many variations of Lorem Ipsum available',
          date: '04 Sep',
        },
        {
          id: 3,
          image: 'assets/images/blog/blog-1-3.jpg',
          alt: 'Suffered alteration',
          title: 'Majority have suffered alteration in some form',
          date: '05 Sep',
        },
      ];
      

  return (
  
   
      <body className="custom-cursor">


{/* <div className="preloader">
    <div className="preloader__image" style={{backgroundImage:'url("assets/images/loader.png")'}}  ></div>
</div> */}
{/* /.preloader */}
<div className="page-wrapper">
    <Preloader/>
    <Header/>
    {/* <Stickeyheader  /> */}

   <Banner/>
    

    <section className="about-one about-one--home section-space">
        <div className="about-one__bg">
            <div className="about-one__bg__border"></div>{/* /.about-one__bg__border */}
            <div className="about-one__bg__inner"
                style={{backgroundImage:'url("assets/images/shapes/about-shape-1-1.png")'}}></div>
            {/* /.about-one__left__bg__inner */}
        </div>{/* /.about-one__left__bg */}
        <div className="container">
            <div className="row gutter-y-50">
                <div className="col-xl-6 wow fadeInLeft" data-wow-delay="00ms" data-wow-duration="1500ms">
                    <div className="about-one__left">
                    <div className="about-one__image">
  <div
    style={{
      position: 'relative', // Needed to contain absolutely positioned images
      paddingLeft: '10px',
      width: '100%',
      height: '400px',
      overflow: 'hidden',
    }}
  >
    {/* Image 1 */}
    <img
      src="assets/images/login/schlimg.jpg"
      alt="about"
      className="about-one__image__one"
      style={{
        position: 'absolute', // Critical for stacking
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        animation: 'fadeSlide 6s infinite',
        animationDelay: '0s',
        opacity: 0,
        animationFillMode: 'forwards',
      }}
    />

    {/* Image 2 */}
    <img
      src="assets/images/login/schlimg1.jpg"
      alt="about2"
      className="about-one__image__one"
      style={{
        position: 'absolute', // Critical for stacking
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        animation: 'fadeSlide 6s infinite',
        animationDelay: '3s',
        opacity: 0,
        animationFillMode: 'forwards',
      }}
    />

    {/* Keyframes for fade/slide */}
    <style>
      {`
        @keyframes fadeSlide {
          0% { opacity: 0; }
          10% { opacity: 1; }
          40% { opacity: 1; }
          50% { opacity: 0; }
          100% { opacity: 0; }
        }
      `}
    </style>
  </div>



                            <div className="about-one__video"
                                style={{backgroundImage:'url("assets/images/home/family.jpg")'}}>
                                <a href='https://youtu.be/gLtWJVSL3tQ?feature=shared'  className="about-one__video__btn video-button video-popup">
                                    <span className="icon-play"></span>
                                    <i className="video-button__ripple"></i>
                                </a>{/* /.about-one__video__btn */}
                            </div>{/* /.about-one__video */}
                            <div className="about-one__profile volunteer-profile">
                                <div className="volunteer-profile__inner">
                                    <img src="assets/images/banner/tree.jpeg" alt="Robert Joe Kerry" /* founder Image */
                                        className="volunteer-profile__image"/>
                                    <div className="volunteer-profile__info">
                                        <h4 className="volunteer-profile__name"><a></a>Mr.Hawkins.K</h4>
                                        <p className="volunteer-profile__designation">Founder</p>
                                        <p className="volunteer-profile__designation">+91 98439 76039</p>
                                    </div>
                                </div>{/* /.volunteer-profile__inner */}
                            </div>{/* /.about-one__profile */}
                        </div>{/* /.about-one__image */}
                    </div>{/* /.about-one__left */}
                </div>

                <div className="col-xl-6">
  <div className="login-page__form">
    <div className="d-flex justify-content-center mb-4">
      <button
        onClick={() => setAdminMode(true)}
        className={`btn ${adminMode ? 'btn-primary' : 'btn-outline-primary'} me-2`}
      >
        Admin Login
      </button>
      <button
        onClick={() => setAdminMode(false)}
        className={`btn ${!adminMode ? 'btn-primary' : 'btn-outline-primary'}`}
      >
        Student Login
      </button>
    </div>

    <span
      className="login-page__form__top-title"
      style={{ backgroundColor: '#ffd767' }}
    >
      {adminMode ? 'Admin Login' : 'Student Login'}
    </span>

    <h2 className="login-page__form__title">
      {adminMode ? 'Welcome to the Admin Portal' : 'Welcome to the Student Portal'}
    </h2>

    {error && <p className="text-danger">{error}</p>}

    <form className="login-page__form__box form-one" onSubmit={handleLogin}>
      <div className="login-page__form__input-box form-one__control">
        {adminMode ? (
          <input
            className="form-one__control__input"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        ) : (
          <input
            className="form-one__control__input"
            type="text"
            placeholder="Aadhaar / Email / User ID"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
        )}
      </div>

      <div className="login-page__form__input-box form-one__control">
        <input
          className="form-one__control__input"
          type={showPassword ? 'text' : 'password'}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <div className="login-page__form__input-box login-page__form__checkbox-forgot">
        <div className="login-page__form__checkbox">
          <input
            type="checkbox"
            id="showPassword"
            checked={showPassword}
            onChange={handleShowPasswordChange}
          />
          <label htmlFor="showPassword">Show Password</label>
        </div>
        <Link to="/forgot-password" className="login-page__form__forgot">
          Forgot your password?
        </Link>
      </div>

      <div className="login-page__form__input-box">
        <button
          type="submit"
          className="cleenhearts-btn"
          disabled={loading}
        >
          <span className="cleenhearts-btn__icon-box">
            <span className="cleenhearts-btn__icon-box__inner">
              <span className="icon-duble-arrow"></span>
            </span>
          </span>
          <span className="cleenhearts-btn__text">
            {loading ? 'Logging in...' : 'Log in'}
          </span>
        </button>
      </div>
    </form>
  </div>
</div>

            </div>{/* /.row */}
        </div>{/* /.container */}
        <img src="assets/images/shapes/about-shape-1-2.png" alt="cleenhearts" className="about-one__hand"/>
    </section>{/* /.about-one section-space */}

    <section className="help-donate-one section-space-top">
        <div className="help-donate-one__bg cleenhearts-jarallax" data-jarallax data-speed="0.3"
            data-imgPosition="50% -100%"
            style={{backgroundImage:'url("assets/images/home/handswithheart.png")'}}></div>
        {/* /.cta-one__bg */}
        <div className="help-donate-one__shape-one" style={{backgroundImage:'url("assets/images/shapes/shape-1.png")'}}>
        </div>{/* /.cta-one__shape-one */}
        <div className="help-donate-one__shape-two" style={{backgroundImage:'url("assets/images/shapes/shape-2.png")'}}>
        </div>{/* /.cta-one__shape-two */}
        <div className="container">
            <div className="sec-title">
                <h6 className="sec-title__tagline sec-title__tagline--center">HELP & DONATE US</h6>
                {/* /.sec-title__tagline */}
            </div>{/* /.sec-title */}
        </div>{/* /.container */}
        <div className="help-donate-one__slide">
            <span
                className="help-donate-one__text help-donate-one__text--one">medicals</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--two">education</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--one">foods</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--two">health</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--one">support</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--two">donation</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--one">medical</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--two">education</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--one">foods</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--two">health</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--one">support</span>{/* /.help-donate-one__text */}
            <img src="assets/images/resources/help-donate-1-1.png" alt="help-donate" className="help-donate-one__image"/>
            <span
                className="help-donate-one__text help-donate-one__text--two">donation</span>{/* /.help-donate-one__text */}
        </div>{/* /.help-donate-one__slide */}
    </section>{/* /.help-donate-one section-space-top */}



    <section>
    <DonationsCarousel/>
    </section>
    <section className="inspiring-one section-space"
        style={{backgroundImage:'url("assets/images/backgrounds/inspiring-bg-1-1.png")'}}>
        <div className="container">
            <div className="row gutter-y-50">
                <div className="col-xl-6">
                    <div className="sec-title">

                        <h6 className="sec-title__tagline @@extraClassName">WHO ARE WE</h6>{/* /.sec-title__tagline */}

                        <h3 className="sec-title__title">Inspiring and Helping for Better <span
                                className="sec-title__title__inner">Lifestyle</span></h3>{/* /.sec-title__title */}
                    </div>{/* /.sec-title */}
                    <p className="inspiring-one__text">Dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas
                        sit aspernaturaut odit aut fugit, sed quia consequuntur. Dicta sunt explicabo. Nemo enim
                        ipsam voluptatem quia voluptas.</p>{/* /.inspiring-one__text */}
                    <div className="inspiring-one__inner">
                        <div className="inspiring-one__inner__content wow fadeInUp" data-wow-duration="1500ms"
                            data-wow-delay="00ms">
                            <h4 className="inspiring-one__inner__title">Become A
                                Volunteer</h4>{/* /.inspiring-one__inner__title */}
                            <div className="inspiring-one__inner__icon">
                                <span className="icon-unity"></span>
                            </div>{/* /.inspiring-one__inner__icon */}
                        </div>{/* /.inspiring-one__inner__content */}
                        <div className="inspiring-one__inner__content wow fadeInUp" data-wow-duration="1500ms"
                            data-wow-delay="200ms">
                            <h4 className="inspiring-one__inner__title">medical &
                                health</h4>{/* /.inspiring-one__inner__title */}
                            <div className="inspiring-one__inner__icon">
                                <span className="icon-healthcare"></span>
                            </div>{/* /.inspiring-one__inner__icon */}
                        </div>{/* /.inspiring-one__inner__content */}
                    </div>{/* /.inspiring-one__inner */}
                </div>{/* /.col-xl-6 */}
                <div className="col-xl-6">
                    <div className="inspiring-one__image">
                        <div className="inspiring-one__image__inner inspiring-one__image__inner--one wow fadeInRight"
                            data-wow-duration="1500ms" data-wow-delay="00ms">
                            <img src="assets/images/home/hands-13201785_960_720.jpg" alt="inspiring"/>
                        </div>{/* /.inspiring-one__image__one */}
                        <div className="inspiring-one__image__inner inspiring-one__image__inner--two wow fadeInRight"
                            data-wow-duration="1500ms" data-wow-delay="200ms">
                            <img src="assets/images/home/abstract-71283_640.jpg" alt="inspiring"/>
                        </div>{/* /.inspiring-one__image__two */}
                    </div>{/* /.inspiring-one__image */}
                </div>{/* /.col-xl-6 */}
            </div>{/* /.row */}
        </div>{/* /.container */}
        <div className="inspiring-one__shapes">
            <div className="inspiring-one__shape inspiring-one__shape--one"></div>{/* /.inspiring-one__shape__one */}
            <div className="inspiring-one__shape inspiring-one__shape--two"></div>{/* /.inspiring-one__shape__one */}
        </div>{/* /.inspiring-one__shape */}
    </section>{/* /.inspiring-one-one section-space */}

    <section className="events-one section-space">
        <div className="container">
            <div className="sec-title">

                <h6 className="sec-title__tagline sec-title__tagline--center">Worldwide non profit charity</h6>
                {/* /.sec-title__tagline */}

                <h3 className="sec-title__title">See Upcoming <span className="sec-title__title__inner">Events</span></h3>
                {/* /.sec-title__title */}
            </div>{/* /.sec-title */}
            <div className="horizontal-accordion">
                <div className="events-one__card card choice">
                    <div className="card-body">
                        <div className="events-one__card__top"
                            style={{backgroundImage:'url("assets/images/home/boy-8474750_1280.jpg")'}}>
                            <h4 className="events-one__card__title">Your little Help Can Heal Pains</h4>
                            <span className="events-one__card__icon icon-plus"></span>{/* /.accordion-title__icon */}
                        </div>{/* /.accordian-title */}
                        <div className="event-card-two">
                            <a  className="event-card-two__image">
                                <img src="assets/images/events/event-2-5.jpg" alt="cleenhearts"/>
                                <div className="event-card-two__time">
                                    <span className="event-card-two__time__icon fa fa-clock"></span>Dec 13, 2024 @ 10:00
                                    am
                                </div>{/* /.event-card-four__time */}
                            </a>{/* /.event-card-four__image */}
                            <div className="event-card-two__content">
                                <h4 className="event-card-two__title"><a >Your little
                                        Help Can Heal Pains</a></h4>{/* /.event-card-four__title */}
                                <div className="event-card-two__text">Dicta sunt explicabo. Nemo enim ipsam voluptatem
                                    quia voluptas sit aspernaturaut odit</div>{/* /.event-card-two__text */}
                                <div className="event-card-two__meta">
                                    <h5 className="event-card-two__meta__title">Vanue</h5>
                                    350 5th AveNew York, NY 10118 United States
                                </div>{/* /.event-card-four__meta */}
                            </div>{/* /.event-card-four__content */}
                        </div>{/* /.event-card-two */}
                    </div>
                </div>
                <div className="events-one__card card choice expand">
                    <div className="card-body">
                        <div className="events-one__card__top"
                            style={{backgroundImage:'url("assets/images/events/event-bg-1-2.jpg")'}}>
                            <h4 className="events-one__card__title">Let’s education for children get good</h4>
                            <span className="events-one__card__icon icon-plus"></span>{/* /.accordion-title__icon */}
                        </div>{/* /.accordian-title */}
                        <div className="event-card-two">
                            <a className="event-card-two__image">
                                <img src="assets/images/home/toddler-238466_1280.jpg" alt="cleenhearts"/>
                                <div className="event-card-two__time">
                                    <span className="event-card-two__time__icon fa fa-clock"></span>Dec 13, 2024 @ 10:00
                                    am
                                </div>{/* /.event-card-four__time */}
                            </a>{/* /.event-card-four__image */}
                            <div className="event-card-two__content">
                                <h4 className="event-card-two__title"><a >Let’s education
                                        for children get good life</a></h4>{/* /.event-card-four__title */}
                                <div className="event-card-two__text">Dicta sunt explicabo. Nemo enim ipsam voluptatem
                                    quia voluptas sit aspernaturaut odit</div>{/* /.event-card-two__text */}
                                <div className="event-card-two__meta">
                                    <h5 className="event-card-two__meta__title">Vanue</h5>
                                    350 5th AveNew York, NY 10118 United States
                                </div>{/* /.event-card-four__meta */}
                            </div>{/* /.event-card-four__content */}
                        </div>{/* /.event-card-two */}
                    </div>
                </div>
                <div className="events-one__card card choice">
                    <div className="card-body">
                        <div className="events-one__card__top"
                            style={{backgroundImage:'url("assets/images/home/hotwater.png")'}}>
                            <h4 className="events-one__card__title">Give African Childrens Education</h4>
                            <span className="events-one__card__icon icon-plus"></span>{/* /.accordion-title__icon */}
                        </div>{/* /.accordian-title */}
                        <div className="event-card-two">
                            <a className="event-card-two__image">
                                <img src="assets/images/events/event-2-7.jpg" alt="cleenhearts"/>
                                <div className="event-card-two__time">
                                    <span className="event-card-two__time__icon fa fa-clock"></span>Dec 13, 2024 @ 10:00
                                    am
                                </div>{/* /.event-card-four__time */}
                            </a>{/* /.event-card-four__image */}
                            <div className="event-card-two__content">
                                <h4 className="event-card-two__title"><a >Give African
                                        Childrens Education</a></h4>{/* /.event-card-four__title */}
                                <div className="event-card-two__text">Dicta sunt explicabo. Nemo enim ipsam voluptatem
                                    quia voluptas sit aspernaturaut odit</div>{/* /.event-card-two__text */}
                                <div className="event-card-two__meta">
                                    <h5 className="event-card-two__meta__title">Vanue</h5>
                                    350 5th AveNew York, NY 10118 United States
                                </div>{/* /.event-card-four__meta */}
                            </div>{/* /.event-card-four__content */}
                        </div>{/* /.event-card-two */}
                    </div>
                </div>
            </div>
        </div>{/* /.container */}
    </section>{/* /.events-one section-space */}

    <section className="testimonials-one section-space">
        <div className="testimonials-one__bg cleenhearts-jarallax" data-jarallax data-speed="0.3"
            data-imgPosition="50% -100%"
            style={{backgroundImage:'url("assets/images/backgrounds/testimonial-bg-1.jpg")'}}></div>
        {/* /.testimonial-one__bg */}
        <div className="container">
            <div className="testimonials-one__wrapper">
                <div className="testimonials-one__top">
                    <div className="row gutter-y-30 align-items-center">
                        <div className="col-lg-7">
                            <div className="sec-title">

                                <h6 className="sec-title__tagline @@extraClassName">TESTIMONIALS</h6>
                                {/* /.sec-title__tagline */}

                                <h3 className="sec-title__title">What They’re Talking About Clean <span
                                        className="sec-title__title__inner">Heart</span></h3>{/* /.sec-title__title */}
                            </div>{/* /.sec-title */}
                        </div>{/* /.col-lg-7 */}
                        <div className="col-lg-5 wow fadeInRight" data-wow-duration="1500ms">
                            <div className="testimonials-one__image">
                                <img src="assets/images/home/alliance-american-arms-blue.jpg" alt="testimonials"/>
                            </div>{/* /.testimonials-one__image */}
                        </div>{/* /.col-lg-5 */}
                    </div>{/* /.row gutter-y-40 */}
                </div>{/* /.testimonials-one__top */}
                <div className="testimonials-one__carousel cleenhearts-owl__carousel cleenhearts-owl__carousel--basic-nav owl-theme owl-carousel"
                    data-owl-options='{
            "items": 1,
            "margin": 10,
            "smartSpeed": 700,
            "loop":true,
            "autoplay": 6000,
            "nav":false,
            "dots":true,
            "navText": ["<span className=\"icon-arrow-left\"></span>","<span className=\"icon-arrow-right\"></span>"],
            "responsive":{
                "0":{
                    "items": 1,
                    "margin": 0
                },
                "575":{
                    "items": 1,
                    "margin": 0
                },
                "768":{
                    "items": 1,
                    "margin": 0
                },
                "992":{
                    "items": 1,
                    "margin": 0
                },
                "1200":{
                    "items": 1,
                    "margin": 0
                }
            }
            }'>
                    <div className="item wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                        <div className="testimonials-card">
                            <div className="testimonials-card__bg"
                                style={{backgroundImage:'url("assets/images/backgrounds/testimonial-bg-2.png")'}}>
                            </div>{/* /.testimonials-card__bg */}
                            <div className="testimonials-card__info">
                                <div className="testimonials-card__info__left">
                                    <h4 className="testimonials-card__name">Kenneth S. Fisher</h4>
                                    {/* /.testimonials-card__name */}
                                    <span className="testimonials-card__designation">marketing
                                        manager</span>{/* /.testimonials-card__designation */}
                                </div>{/* /.testimonials-card__info__left */}
                                <div className="cleenhearts-ratings testimonials-card__rattings">
                                    <span className="icon-star"></span><span className="icon-star"></span><span
                                        className="icon-star"></span><span className="icon-star"></span><span
                                        className="icon-star"></span>
                                </div>{/* /.product-ratings */}
                            </div>{/* /.testimonials-card__info */}
                            <div className="testimonials-card__content">
                                <p className="testimonials-card__text">posuere luctus orci. Donec vitae mattis quam,
                                    vitae tempor arcu. Aenean<br/> non odio porttitor, convallis erat sit amet,
                                    facilisis velit. Nulla ornare<br/> convallis malesuada. Phasellus</p>
                                {/* /.testimonials-card__text */}
                                <div className="testimonials-card__quote">
                                    <span className="icon-quote"></span>
                                </div>{/* /.testimonials-card__quote */}
                            </div>{/* /.testimonials-card__content */}
                        </div>{/* /.testimonials-card */}
                    </div>{/* /.item*/}
                    <div className="item wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                        <div className="testimonials-card">
                            <div className="testimonials-card__bg"
                                style={{backgroundImage:'url("assets/images/backgrounds/testimonial-bg-2.png")'}}>
                            </div>{/* /.testimonials-card__bg */}
                            <div className="testimonials-card__info">
                                <div className="testimonials-card__info__left">
                                    <h4 className="testimonials-card__name">Cedric J. Coggins</h4>
                                    {/* /.testimonials-card__name */}
                                    <span className="testimonials-card__designation">Tropical
                                        zodiac</span>{/* /.testimonials-card__designation */}
                                </div>{/* /.testimonials-card__info__left */}
                                <div className="cleenhearts-ratings testimonials-card__rattings">
                                    <span className="icon-star"></span><span className="icon-star"></span><span
                                        className="icon-star"></span><span className="icon-star"></span><span
                                        className="icon-star"></span>
                                </div>{/* /.product-ratings */}
                            </div>{/* /.testimonials-card__info */}
                            <div className="testimonials-card__content">
                         

                                <p className="testimonials-card__text">posuere luctus orci. Donec vitae mattis quam,
                                    vitae tempor arcu. Aenean<br/> non odio porttitor, convallis erat sit amet,
                                    facilisis velit. Nulla ornare<br/> convallis malesuada. Phasellus</p>
                                {/* /.testimonials-card__text */}
                                <div className="testimonials-card__quote">
                                    <span className="icon-quote"></span>
                                </div>{/* /.testimonials-card__quote */}
                            </div>{/* /.testimonials-card__content */}
                        </div>{/* /.testimonials-card */}
                    </div>{/* /.item*/}
                    <div className="item wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                        <div className="testimonials-card">
                            <div className="testimonials-card__bg"
                                style={{backgroundImage:'url("assets/images/backgrounds/testimonial-bg-2.png")'}}>
                            </div>{/* /.testimonials-card__bg */}
                            <div className="testimonials-card__info">
                                <div className="testimonials-card__info__left">
                                    <h4 className="testimonials-card__name">Jhon Doe</h4>
                                    {/* /.testimonials-card__name */}
                                    <span className="testimonials-card__designation">marketing
                                        manager</span>{/* /.testimonials-card__designation */}
                                </div>{/* /.testimonials-card__info__left */}
                                <div className="cleenhearts-ratings testimonials-card__rattings">
                                    <span className="icon-star"></span><span className="icon-star"></span><span
                                        className="icon-star"></span><span className="icon-star"></span><span
                                        className="icon-star"></span>
                                </div>{/* /.product-ratings */}
                            </div>{/* /.testimonials-card__info */}
                            <div className="testimonials-card__content">
                                <p className="testimonials-card__text">posuere luctus orci. Donec vitae mattis quam,
                                    vitae tempor arcu. Aenean<br/> non odio porttitor, convallis erat sit amet,
                                    facilisis velit. Nulla ornare<br/> convallis malesuada. Phasellus</p>
                                {/* /.testimonials-card__text */}
                                <div className="testimonials-card__quote">
                                    <span className="icon-quote"></span>
                                </div>{/* /.testimonials-card__quote */}
                            </div>{/* /.testimonials-card__content */}
                        </div>{/* /.testimonials-card */}
                    </div>{/* /.item*/}
                </div>{/* /.testimonials-one__carousel */}
            </div>{/* /.testimonials-one__wrapper */}
        </div>{/* /.container */}
        <div className="testimonials-one__shape">
            <img src="assets/images/shapes/shape-1.png" alt="shape" className="testimonials-one__shape__one"/>
            <img src="assets/images/shapes/shape-2.png" alt="shape" className="testimonials-one__shape__two"/>
        </div>{/* /.testimonials-one__shape */}
    </section>{/* /.testimonials-one section-space */}

    <div className="support-one section-space">
        <div className="container">
            <div className="sec-title">

                <h6 className="sec-title__tagline sec-title__tagline--center">Worldwide non profit charity</h6>
                {/* /.sec-title__tagline */}

                <h3 className="sec-title__title">Give a Helping Hand a For Needy <span
                        className="sec-title__title__inner">People</span></h3>{/* /.sec-title__title */}
            </div>{/* /.sec-title */}
            <div className="row gutter-y-30">
                <div className="col-xl-6 col-lg-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                    <div className="support-card">
                        <a  className="support-card__image">
                            <img src="assets/images/support/support-1-1.jpg" alt="Foods Support"/>
                        </a>{/* /.support-card__image */}
                        <a  className="support-card__content">
                            <div className="support-card__content__inner">
                                <h3 className="support-card__title">Foods Support</h3>{/* /.support-card__title */}
                                <div className="support-card__collected"></div>
                                {/* /.support-card__collected */}
                            </div>{/* /.support-card__content__inner */}
                        </a>{/* /.support-card__content */}
                    </div>{/* /.support-card */}
                </div>{/* /.col-xl-6 col-lg-6 */}
                <div className="col-xl-6 col-lg-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                    <div className="support-card">
                        <a  className="support-card__image">
                            <img src="assets/images/support/support-1-2.jpg" alt="Sports Support"/>
                        </a>{/* /.support-card__image */}
                        <a className="support-card__content">
                            <div className="support-card__content__inner">
                                <h3 className="support-card__title">Sports Support</h3>{/* /.support-card__title */}
                                <div className="support-card__collected"></div>
                                {/* /.support-card__collected */}
                            </div>{/* /.support-card__content__inner */}
                        </a>{/* /.support-card__content */}
                    </div>{/* /.support-card */}
                </div>{/* /.col-xl-6 col-lg-6 */}
                <div className="col-xl-6 col-lg-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                    <div className="support-card support-card--direction">
                        <a  className="support-card__content">
                            <div className="support-card__content__inner">
                                <h3 className="support-card__title">Medical Support</h3>{/* /.support-card__title */}
                                <div className="support-card__collected"></div>
                                {/* /.support-card__collected */}
                            </div>{/* /.support-card__content__inner */}
                        </a>{/* /.support-card__content */}
                        <a  className="support-card__image">
                            <img src="assets/images/support/support-1-3.jpg" alt="Medical Support"/>
                        </a>{/* /.support-card__image */}
                    </div>{/* /.support-card */}
                </div>{/* /.col-xl-6 col-lg-6 */}
                <div className="col-xl-6 col-lg-6 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                    <div className="support-card support-card--direction">
                        <a  className="support-card__content">
                            <div className="support-card__content__inner">
                                <h3 className="support-card__title">Education Support</h3>{/* /.support-card__title */}
                                <div className="support-card__collected"></div>
                                {/* /.support-card__collected */}
                            </div>{/* /.support-card__content__inner */}
                        </a>{/* /.support-card__content */}
                        <a className="support-card__image">
                            <img src="assets/images/support/support-1-4.jpg" alt="Education Support"/>
                        </a>{/* /.support-card__image */}
                    </div>{/* /.support-card */}
                </div>{/* /.col-xl-6 col-lg-6 */}
            </div>{/* /.row */}
        </div>{/* /.container */}
        <div className="support-one__shape">
            <img src="assets/images/shapes/support-shape-hand-1-1.png" alt="shape-hand"
                className="support-one__shape__one"/>
            <img src="assets/images/shapes/support-shape-hand-1-2.png" alt="shape-hand"
                className="support-one__shape__two"/>
        </div>{/* /.support-one__shape */}
    </div>{/* /.support-one section-space */}

    <section className="help-people" style={{backgroundImage:' url("assets/images/backgrounds/help-people-bg-1.png")'}}>
        <div className="container">
            <div className="row">
                <div className="help-people__images col-xl-6">
                    <div className="help-people__images__inner">
                        <img src="assets/images/help-people/help-people-1-1.png" alt="help-people"
                            className="wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="800ms"/>
                        <img src="assets/images/help-people/help-people-1-2.png" alt="help-people"
                            className="wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="400ms"/>
                        <img src="assets/images/help-people/help-people-1-3.png" alt="help-people"
                            className="wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="00ms"/>
                    </div>{/* /.help-people__images__inner */}
                </div>{/* /.col-xl-6 */}
                <div className="help-people__content col-xl-6">
                    <div className="help-people__content__inner">
                        <div className="sec-title">

                            <h6 className="sec-title__tagline @@extraClassName">Help people now</h6>
                            {/* /.sec-title__tagline */}

                            <h3 className="sec-title__title">Charity For The People You Care <span
                                    className="sec-title__title__inner">About</span></h3>{/* /.sec-title__title */}
                        </div>{/* /.sec-title */}
                        <p className="help-people__text">Dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas
                            sit aspernaturaut odit aut fugit, sed quia consequuntur. Dicta sunt explicabo. Nemo enim
                            ipsam voluptatem quia voluptas.</p>{/* /.help-people__text */}
                        <div className="help-people__content__bottom">
                            <a  className="cleenhearts-btn">
                                <div className="cleenhearts-btn__icon-box">
                                    <div className="cleenhearts-btn__icon-box__inner"><span
                                            className="icon-duble-arrow"></span></div>
                                </div>
                                <span className="cleenhearts-btn__text">Become A Volunteer</span>
                            </a>{/* /.cleenhearts-btn */}
                            <div className="volunteer-group">
                                <a  className="volunteer-group__link">
                                    <img src="assets/images/volunteer/volunteer-image-1.png" alt="volunteer"
                                        className="volunteer-group__image"/>
                                </a>{/* /.volunteer-group__link */}
                                <a  className="volunteer-group__link">
                                    <img src="assets/images/volunteer/volunteer-image-2.png" alt="volunteer"
                                        className="volunteer-group__image"/>
                                </a>{/* /.volunteer-group__link */}
                                <a  className="volunteer-group__link">
                                    <img src="assets/images/volunteer/volunteer-image-3.png" alt="volunteer"
                                        className="volunteer-group__image"/>
                                </a>{/* /.volunteer-group__link */}
                            </div>{/* /.volunteer-group */}
                        </div>{/* /.help-people__content__bottom */}
                    </div>{/* /.help-people__content__inner */}
                </div>{/* /.col-xl-6 */}
            </div>{/* /.row */}
        </div>{/* /.container */}
        <div className="help-people__shape">
            <img src="assets/images/shapes/help-people-shape-1.png" alt="help-people"
                className="help-people__shape__one"/>
        </div>{/* /.help-people__shape */}
    </section>{/* /.help-people */}





    <div className="blog-one section-space">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-7 col-md-9">
            <div className="sec-title">
              <h6 className="sec-title__tagline">Our latest news</h6>
              <h3 className="sec-title__title">Latest News & Articles From Clean <span className="sec-title__title__inner">Heart</span></h3>
            </div>
          </div>
        </div>

        <OwlCarousel className="blog-one__carousel owl-theme" {...options}>
          {blogPosts.map(post => (
            <div className="item" key={post.id}>
              <div className="blog-card">
                <a className="blog-card__image">
                  <img src={post.image} alt={post.alt} />
                  <div className="blog-card__date"><span>{post.date.split(' ')[0]}</span> {post.date.split(' ')[1]}</div>
                </a>
                <div className="blog-card__content" style={{ backgroundImage: 'url("assets/images/blog/blog-bg-1-1.png")' }}>
                  <h3 className="blog-card__title"><a >{post.title}</a></h3>
                  <a  className="blog-card__link">
                    <span className="blog-card__link__front"><span className="icon-duble-arrow"></span></span>
                    <span className="blog-card__link__back"><span className="icon-duble-arrow"></span>Read More</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </div>









    <section className="donars-one donars-one--home section-space"
        style={{backgroundImage:'url("assets/images/backgrounds/donors-bg.png")'}}>
        <div className="container-fluid">
            <div className="sec-title">

                <h6 className="sec-title__tagline sec-title__tagline--center">OUR DONARS</h6>
                {/* /.sec-title__tagline */}

                <h3 className="sec-title__title">Top <span className='sec-title__title__inner'>Donor</span> Countries</h3>
                {/* /.sec-title__title */}
            </div>{/* /.sec-title */}
            <div className="donars-one__row donars-one__row--top">
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-usa.png" alt="usa" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">USA English</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-british.png" alt="british"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">british engliah</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-canada.png" alt="canada"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">canada english</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-irish.png" alt="irish" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">irish english</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-turkish.png" alt="turkish"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">turkish</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-italian.png" alt="italian"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">italian</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-french.png" alt="french"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">french</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-japan.png" alt="japanese"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">japanese</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-chinese.png" alt="chinese"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">chinese</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-bangladesh.png" alt="bangladesh"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">bangladesh</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-malay.png" alt="malay" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">malay</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-filipino.png" alt="filipino"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">filipino</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-portages.png" alt="portages"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">portages</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-australia.png" alt="australia"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">australia</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-usa.png" alt="usa" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">USA English</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-british.png" alt="british"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">british engliah</span>
                </div>{ /* /.donars-one__country */}
            </div> {/* /.donars-one__row */}
            <div className="donars-one__row donars-one__row--bottom">
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-usa.png" alt="usa" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">USA English</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-british.png" alt="british"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">british engliah</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-canada.png" alt="canada"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">canada english</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-irish.png" alt="irish" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">irish english</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-turkish.png" alt="turkish"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">turkish</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-italian.png" alt="italian"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">italian</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-japan.png" alt="japanese"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">japanese</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-chinese.png" alt="chinese"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">chinese</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-india.png" alt="india" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">hindi</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-bangladesh.png" alt="bangladesh"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">bangladesh</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-malay.png" alt="malay" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">malay</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-filipino.png" alt="filipino"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">filipino</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-portages.png" alt="portages"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">portages</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-australia.png" alt="australia"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">australia</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-usa.png" alt="usa" className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">USA English</span>
                </div>{/* /.donars-one__country */}
                <div className="donars-one__country">
                    <img src="assets/images/resources/flag-british.png" alt="british"
                        className="donars-one__country__flag"/>
                    <span className="donars-one__country__text">british engliah</span>
                </div>{/* /.donars-one__country */}
            </div>{/* /.donars-one__row */}
        </div>{/* /.container-fluid */}
    </section>{/* /.donars-one section-space */}

    <ClientCarousel/>
</div>
<Footer/>
</body>
   
  )
}

export default Index



























